import React from 'react'
import { Grid } from '@mui/material'

import { StyledButton } from 'shared'

const PostponedFormActionButtons = ({
  onSubmit,
  submitTitle = 'Continue',
  onBack,
}: {
  onSubmit: () => void
  submitTitle?: string
  onBack?: () => void
}) => {
  return (
    <Grid container justifyContent="flex-end" gap="20px">
      {onBack ? (
        <StyledButton variant="contained" color="light" onClick={onBack}>
          Back
        </StyledButton>
      ) : null}
      <StyledButton
        variant="contained"
        color="primary"
        type="submit"
        onClick={onSubmit}
      >
        {submitTitle}
      </StyledButton>
    </Grid>
  )
}

export default PostponedFormActionButtons
